/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { FunctionComponent, useCallback } from "react";
import "./ShareStats.scss";
import { SvgHeart, SvgVisibilityShow } from "@itwin/itwinui-icons-react";
import { SvgBranch } from "components/icons/SvgBranch";


export interface ShareStatsProps {
  likes: number;
  views: number;
  forks: number;
}

export const ShareStats: FunctionComponent<ShareStatsProps> = ({ likes, views, forks }) => {

  const formatValue = useCallback((val: number) => {
    if (val > 1000) {
      return `${(val / 1000).toPrecision(2)}k`;
    }
    return val.toString();
  }, []);

  return (
    <div className="share-stats" aria-label="share stats">
      <div className="stat" aria-label="likes" title={`Likes: ${likes}`}>
        <SvgHeart className={"icon likes"} />
        <span aria-label="amount of likes" >{formatValue(likes)}</span>
      </div>
      <div className="stat" aria-label="forks" title={`Forks: ${forks}`}>
        <SvgBranch className={"icon forks"} />
        <span aria-label="amount of forks" >{formatValue(forks)}</span>
      </div>
      <div className="stat" aria-label="views" title={`Views: ${views}`}>
        <SvgVisibilityShow className={"icon views"} />
        <span aria-label="amount of views" >{formatValue(views)}</span>
      </div>
    </div>
  );
};
